var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.successful)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.userFeedback))]):_vm._e(),(_vm.failed)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.userFeedback))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }